// https://docs.google.com/document/d/1YU5qnTMQsd0wgrxkyJ0YqvLfneozhkkn0AJCh8aV68g

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Storage } from '../decorators/storage.decorator';

interface AngularHistoryState {
  navigationId: number;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root',
})
export class BackLinkService {

  // Dados persistentes
  @Storage('originId') originId?: number;
  @Storage('originPath') originPath?: string;
  @Storage('originToken') originToken?: string; // <--- NOVO: Assinatura da sessão

  // Token volátil (morre se der F5 ou fechar a aba)
  private readonly currentSessionToken: string;

  private readonly smartBackRoutes: string[] = [
    '/paciente/home/pedidos-de-exame',
    '/paciente/home/enviar-exames'
  ];

  constructor(
    private router: Router,
    private location: Location
  ) {
    // Gera um ID único para ESTA instância da aplicação na memória.
    // Se der F5, esse número muda.
    this.currentSessionToken = Math.random().toString(36).substring(2);
  }

  setOrigin(): void {
    const currentState = window.history.state as AngularHistoryState;

    if (currentState?.navigationId) {
      this.originId = currentState.navigationId;
      this.originPath = location.pathname;
      this.originToken = this.currentSessionToken;
    }
  }

  goBack(): void {
    const currentPath = location.pathname;

    if (!this.smartBackRoutes.includes(currentPath)) {
      this.fallbackBack();
      return;
    }

    if (this.originToken !== this.currentSessionToken) {
      console.warn('[BackLink] Sessão expirada ou refresh detectado. Usando fallback.');
      this.forceHome(); // Usa back normal em vez de forceHome
      return;
    }

    const currentState = window.history.state as AngularHistoryState;
    const currentId = currentState?.navigationId;
    const originId = Number(this.originId);

    const hasValidData = !!currentId && !isNaN(originId) && this.originId !== undefined;

    if (!hasValidData) {
      this.fallbackBack();
      return;
    }

    const delta = originId - currentId;

    if (delta < 0 && this.originPath !== currentPath) {
      this.clearOrigin();
      window.history.go(delta);
    } else {
      console.warn('[BackLink] Delta inválido. Usando fallback.');
      this.fallbackBack();
    }
  }

  private clearOrigin(): void {
    this.originId = undefined;
    this.originPath = undefined;
    this.originToken = undefined;

    localStorage.removeItem('originId');
    localStorage.removeItem('originPath');
    localStorage.removeItem('originToken');
  }

  private fallbackBack(): void {
    this.clearOrigin(); // Limpa para não tentar smart back de novo

    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/');
    }
  }

  private forceHome(): void {
    this.clearOrigin();
    this.router.navigateByUrl('/');
  }
}
